import { jsx as s } from "react/jsx-runtime";
import { useChatbotContext as o } from "../../hooks/useChatbotContext.js";
function m(r) {
  const { cn: e, isEditing: i, isLoading: t, isPopup: n } = o();
  return /* @__PURE__ */ s(
    "fieldset",
    {
      ...r,
      disabled: i || t,
      className: e(
        "relative mx-4 flex animate-fadeIn items-stretch rounded-medium border border-input bg-card text-foreground shadow shadow-primary/10 ring ring-transparent ring-offset-2 ring-offset-background transition focus-within:ring-ring disabled:cursor-wait disabled:hover:ring-transparent @notMobile:mx-5",
        {
          "mb-8": !n
        },
        r.className
      )
    }
  );
}
export {
  m as UserMessageField
};
